import api from "@services/apiList";
import { getConstants } from "@utilifiles/methods/storage/storage";
import instance from "@services/services";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { ConsentForm } from "./types";

const {clinicId} = getConstants()

const errorResponse: Omit<ResponseType<any>, "response"> = {
  responseIndicator: "fail",
  responseMessage: "Something went wrong",
  statusCode: "500",
};


const {emr}=api

export const getProcedureForm = async (
  encounteriD: number
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(`${emr.procedureForm}${encounteriD}?clinicId=${clinicId}`)
    return result.data
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};
export const getMedicalConsent = async (
  encounteriD: number
): Promise<ResponseType<any>> => {
 
  try {
    const result = await instance.get(`${emr.medicalConsentFrom}${encounteriD}?clinicId=${clinicId}`)
    return result.data
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const getGeneralConsent = async (
  encounteriD: number
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(`${emr.generalConSentForm}${encounteriD}?clinicId=${clinicId}`)
    return result.data
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const geAttendanceCertificate = async (
  id: number
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(`${emr.Attendence}${id}?clinicId=${clinicId}`)
    return result.data
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const SaveReferalLetter = async (
  body: any
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.post(`${emr.referalLetter}`,body)
    return result.data
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};
export const getSickLeave = async (body: any): Promise<ResponseType<any>> => {
  try {
    const result = await instance.post(`${emr.sickLeave}`,body)
    return result.data
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};
export const AttendedLeaveCertificate = async (
  body: any
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.post(`${emr.AttendedLeaveCertificate}`,body)
    return result.data
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const fitCertificate = async (body: any): Promise<ResponseType<any>> => {
  try {
    const result = await instance.post(`${emr.fitFor}`,body)
    return result.data
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};
export const caseinjury = async (body: any): Promise<ResponseType<any>> => {
  try {
    const result = await instance.post(`${emr.caseInjuary}`,body)
    return result.data
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const geDisChargeSummary = async (
  {id,tenetClinicId}:{id: number,tenetClinicId:number}
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(`${emr.dischargeSummary}${id}?clinicId=${tenetClinicId}`)
    return result.data
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};



// services.ts
export const consentFormMaster = async (file: File): Promise<ResponseType<any>> => {
  const formData = new FormData();
  
  // Ensure "file" matches the @RequestParam name in your Java Backend
  formData.append("file", file); 

  const result = await instance.post(emr.consentFormsMaster, formData);
  return result.data;
};

export const saveConsentFormMaster = async (
  payload: any
): Promise<ResponseType<any>> => {

  const result = await instance.post(
    emr.consentFormMasterSave,
    payload
  );

  return result.data;
};


export const getConsentForm = async (
  id: number
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(`${emr.getConsentForm}${id}`)
    return result.data
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const getAllConsentFormList = async (): Promise<ResponseType<ConsentForm[] | null>> => {
  try {
    const result = await instance.get(`${emr.getAllConsentFormList}`)
    return result.data
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};
  
export const geDisChargeSummaryv2 = async ({id,insname}:{
  id: number,
  insname: string
}): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(`${emr.dischargeSummaryv2}/${id}?clinicId=${clinicId}&insname=${insname}`)
    return result.data
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

